import { defineMessages } from 'react-intl'

export default defineMessages({
  description: {
    id: 'ShareWithUsers.Description',
    defaultMessage:
      "Only owners can edit this {descriptor}, so it's a best practice to share this {descriptor} with at least one other owner. Can't find someone? You may need to ask your Space Admin to assign them the App Owner role."
  },
  agentDescription: {
    id: 'ShareWithUsers.Description',
    defaultMessage:
      "Only owners can edit this agent, so it's a best practice to share this agent with at least one other owner. Can't find someone? You may need to ask your Space Admin to assign them the Agent Owner role."
  },
  datasourceDescription: {
    id: 'ShareWithUsers.DatasourceDescription',
    defaultMessage:
      "Only owners can edit this {descriptor}, so it's best practice to share it with at least one other owner. Owners will be able to see this in their list of {descriptor}s."
  },
  readOnlyDescription: {
    id: 'ShareWithUsers.ReadOnlyDescription',
    defaultMessage: 'Only owners can edit this {descriptor}. Contact an owner of this {descriptor} to be added.'
  },
  placeholder: {
    id: 'ShareWithUsers.Placeholder',
    defaultMessage: 'Add an owner'
  }
})
